import React from 'react';

interface FooterProps {
    message: string;
}

/**
 * Diagonal ribbon across the bottom-left corner naming the deployment stage.
 * Rendered only for non-production stages, where VITE_STAGE_NAME is empty, so
 * the ribbon never covers content for end users.
 */
export const Footer: React.FC<FooterProps> = ({message}) => {
    if (!message) {
        return null;
    }

    return (
        <footer className={"footer"} aria-label="Deployment stage">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{message}
        </footer>
    );
};
